import { render, staticRenderFns } from "./questions-type.vue?vue&type=template&id=d656956c&scoped=true"
import script from "./questions-type.vue?vue&type=script&lang=js"
export * from "./questions-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d656956c",
  null
  
)

export default component.exports